import script from "./AppBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBadge.vue?vue&type=script&setup=true&lang=js"

import "./AppBadge.vue?vue&type=style&index=0&id=91e3bea2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91e3bea2"]])

export default __exports__